module.exports = __webpack_public_path__ + "media/music/synth_chords_5-00314b04.mp3";